import { render, staticRenderFns } from "./translations_editor.vue?vue&type=template&id=fcdb2a92&"
import script from "./translations_editor.vue?vue&type=script&lang=js&"
export * from "./translations_editor.vue?vue&type=script&lang=js&"
import style0 from "./translations_editor.vue?vue&type=style&index=0&id=fcdb2a92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports